import React from "react";
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { transitions, breakpoints, functions } = theme;
  const { transparentSidenav, miniSidenav } = ownerState;
  const sidebarWidth = 260;
  const { pxToRem } = functions;

  const commonDesktop = {
    backgroundColor: transparentSidenav ? "transparent" : "#ffffff",
    boxShadow: transparentSidenav ? "none" : "0 10px 40px rgba(15,23,42,.07)",
    border: transparentSidenav ? "none" : "1px solid #E2E8F0",
    left: 14,
    top: 14,
    bottom: 14,
    height: "auto",
    borderRadius: 18,
    overflowX: "hidden",
  };

  const drawerOpenStyles = () => ({
    transform: "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),
    [breakpoints.up("xl")]: {
      ...commonDesktop,
      width: sidebarWidth,
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color", "box-shadow"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  });

  const drawerCloseStyles = () => ({
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),
    [breakpoints.up("xl")]: {
      ...commonDesktop,
      width: pxToRem(88),
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  });

  return {
    "& .MuiDrawer-paper": {
      border: "none",
      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
      scrollbarWidth: "thin",
      scrollbarColor: "#CBD5E1 transparent",
      "&::-webkit-scrollbar": { width: 5 },
      "&::-webkit-scrollbar-thumb": { background: "#CBD5E1", borderRadius: 99 },
    },
  };
});
